import type { ReactElement } from 'react'

import type { ExpandArea } from '../../../recoil/cursor'
import { RSheetsStyle } from '../../util/RSheetsStyle'

export const CopyingCursorBox = ({
  asFixed,
  headerHeight,
  copiedArea: { fixedRightWidth, height, width, x, y },
}: {
  asFixed: boolean
  headerHeight: number
  copiedArea: ExpandArea
}): ReactElement => {
  const boxWidth = asFixed ? fixedRightWidth : width

  if (boxWidth === 0) {
    return <></>
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: y + headerHeight,
        left: x,
        width: boxWidth,
        height,
        pointerEvents: 'none',
        border: `2px #3274E0 dashed`,
        zIndex: asFixed ? RSheetsStyle.zIndex.cursorWhenLeftFixed : RSheetsStyle.zIndex.cursor,
      }}
    />
  )
}
